// @greenlight-spec: 07-source-control-pipeline.md §GitHub App creation flow
import * as React from 'react';

/**
 * Re-run `refetch` whenever the tab regains focus/visibility. The GitHub App
 * manifest handshake (`submitManifestForm`, `@/lib/githubManifest`) opens in a
 * new tab rather than navigating the caller away, so nothing here reruns when
 * the App gets created in that other tab — this is what picks the change back
 * up the moment the user switches back, without a manual reload.
 */
export function useRefetchOnFocus(refetch: () => void): void {
  React.useEffect(() => {
    const onVisible = (): void => {
      if (document.visibilityState === 'visible') refetch();
    };
    document.addEventListener('visibilitychange', onVisible);
    window.addEventListener('focus', onVisible);
    return () => {
      document.removeEventListener('visibilitychange', onVisible);
      window.removeEventListener('focus', onVisible);
    };
  }, [refetch]);
}
